import { emptyArray } from 'utils'

import { CLOSE_SNACKBAR, ENQUEUE_SNACKBAR, REMOVE_SNACKBAR } from './constants'
import type { Notification, NotificationAction } from './types'

export default (state: Notification[] = emptyArray, { key, type, payload }: NotificationAction) => {
  switch (type) {
    case ENQUEUE_SNACKBAR:
      return [
        ...state,
        {
          key,
          message: payload.message,
          options: {
            key,
            variant: payload.variant,
          },
        },
      ]

    case CLOSE_SNACKBAR:
      return state.map((notification: Notification) =>
        payload.dismissAll || notification.key === key ? { ...notification, dismissed: true } : { ...notification },
      )

    case REMOVE_SNACKBAR:
      return state.filter((notification: Notification) => notification.key !== key)

    default:
      return state
  }
}
